// Core constants mirroring the original Meritous C source.

export const RES_SCALE = 2;

export const BASE_SCREEN_W = 640;
export const BASE_SCREEN_H = 480;
export const BASE_TILE = 32;
export const BASE_PLAYERW = 16;
export const BASE_PLAYERH = 24;

export const SCREEN_W = BASE_SCREEN_W * RES_SCALE;
export const SCREEN_H = BASE_SCREEN_H * RES_SCALE;

export const PLAYERW = BASE_PLAYERW * RES_SCALE;
export const PLAYERH = BASE_PLAYERH * RES_SCALE;

export const SCREEN_CX = SCREEN_W / 2;
export const SCREEN_CY = SCREEN_H / 2;

/** Scale a legacy (1x) pixel value to the current coordinate system. */
export const S = (n: number): number => n * RES_SCALE;

// key_held[] virtual key indices (levelblit.h)
export const K_UP = 0;
export const K_DN = 1;
export const K_LT = 2;
export const K_RT = 3;
export const K_SP = 4;

// Map dimensions (mapgen.c NewLevel)
export const MAP_W = 512;
export const MAP_H = 512;

export const TILE = BASE_TILE * RES_SCALE;

// Fixed timestep: the original targets ~30 Hz (frame_len = 33ms).
export const FRAME_MS = 33;
